import { Mutations } from 'vuex-smart-module';
import { Organizations } from '../../../types';
import PartnerCompanyState from './state';

export default class PartnerCompanyMutations extends Mutations<PartnerCompanyState> {
  SET_SERVICE_CENTERS(centers: Organizations.ServiceCenter[]) {
    this.state.service_centers = centers;
  }
}
